// extracted by mini-css-extract-plugin
module.exports = {"root":"PageBackdrop_root___sAtv","wrapper":"PageBackdrop_wrapper__6iqmG","show":"PageBackdrop_show__bwNeO","active":"PageBackdrop_active__OlN7w"};